<template>
  <!-- width="600px" 或者  width="60%"   -->
  <el-dialog
    :close-on-click-modal="false"
    title="添加客户"
    :show-close="true"
    :visible="true"
    :before-close="handleBeforeClose"
    width="525px"
  >
    <div class="dialog__container">
      <el-form
        :model="form"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <div>
          <el-form-item label="客户名称：" prop="customerName">
            <el-input
              clearable
              :disabled="!canEditClientName"
              placeholder="请输入客户名称"
              size="mini"
              v-model="form.customerName"
            ></el-input>
          </el-form-item>
          <el-form-item label="联系方式：" prop="customerPhone">
            <el-input
              clearable
              :disabled="!canEditClientName"
              placeholder="请输入联系方式"
              size="mini"
              v-model="form.customerPhone"
            ></el-input>
          </el-form-item>
          <el-form-item label="地址：" prop="customerAddress">
            <el-input
              clearable
              :disabled="!canEditClientName"
              placeholder="请输入地址"
              size="mini"
              v-model="form.customerAddress"
            ></el-input>
          </el-form-item>
          <el-form-item label="使用单位：" prop="propertyUnitId">
            <el-select
              size="mini"
              v-model="propertyObj"
              filterable
              multiple
              placeholder="请选择使用单位"
              clearable
              reserve-keyword
              :remote="true"
              @change="chooseProperty"
              :remote-method="searchUnitList"
              @visible-change="searchUnitList('')"
              value-key="id"
            >
              <el-option
                v-for="item in unitList"
                :key="item.id"
                :label="item.unitName"
                :value="item"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button
        class="plr28"
        size="mini"
        type="info"
        plain
        @click="handleCancel"
        >取消</el-button
      >
      <el-button class="plr28" type="primary" size="mini" @click="handleConfirm"
        >确定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { getUnitSimpleList } from "@/api/ProjectManagement";
import { saveCustomer } from "@/api/CustomerManagement";
export default {
  props: {
    clientForm: {
      type: Object,
      required: false,
      default: () => ({
        customerName: "",
        customerPhone: "",
        customerAddress: "",
        id: "",
        propertyUnitIdList: [],
      }),
    },
  },
  data() {
    return {
      propertyObj: null,
      canEditClientName: true,
      unitList: [],
      form: {
        customerName: "",
        customerPhone: "",
        customerAddress: "",
        id: "",
        propertyUnitIdList: [],
      },

      loading: false,
      rules: {
        customerName: [
          {
            required: true,
            message: "请输入客户名称",
            trigger: "blur",
          },
        ],
        customerPhone: [
          {
            required: true,
            message: "请输入联系方式",
            trigger: "blur",
          },
        ],
      },
    };
  },
  created() {
    if (this.clientForm && this.clientForm.id) {
      // 说明是添加客户联系人的
      this.form.customerName = this.clientForm.customerName;
      this.form.customerPhone = this.clientForm.customerPhone;
      this.form.customerAddress = this.clientForm.customerAddress;
      this.form.propertyUnitIdList = this.clientForm.propertyUnitIdList;
      if (this.clientForm.propertyUnitIdList && this.clientForm.propertyUnitIdList.length) {
        this.propertyObj = this.clientForm.propertyUnitIdList.map(id =>({id: id}))
      }
      this.form.id = this.clientForm.id;
      this.canEditClientName = true;
    } else {
      this.canEditClientName = true;
    }
    this.searchUnitList();
  },
  methods: {
    chooseProperty(data) {
      console.log(data)
      if (data && data.length) {
        this.form.propertyUnitIdList = data.map((item) => item.id);
      } else {
        this.form.propertyUnitIdList = [];
      }
    },
    async searchUnitList(keyword) {
      const res = await getUnitSimpleList({
        keyword: keyword,
        size: 100,
      });
      if (res.code === 200) {
        this.unitList = res.data;
      }
    },
    handleBeforeClose(done) {
      this.$emit("cancel");
      done();
    },

    handleCancel() {
      this.$emit("cancel");
    },
    handleConfirm() {
      this.$refs["ruleForm"].validate(async (valid) => {
        if (!valid) return;
        this.loading = true;
        console.log(this.form);
        const res = await saveCustomer(this.form);
        this.loading = false;
        if (res.code === 200) {
          if (this.clientForm && this.clientForm.id) {
            this.$message.success("编辑成功");
          } else {
            this.$message.success("添加成功");
          }
          this.$emit('confirm')
        }
      });
    },
  },
};
</script>

<style lang="scss">
.add-contacts-text-btn {
  margin-left: 10px;
}
.delete-btn {
  color: #f56c6c;
}
</style>



// WEBPACK FOOTER //
// src/pages/CustomerManagement/components/AddUser.vue